module.exports = __webpack_public_path__ + "img/first-modal-background-optimized.2e0d74bc.jpg";